// Constants
export const archivo_plano = () => {
    return {
        archivo_plano: {
            id: {
                namepath: ['aportes_registrar', 'archivo_aportes', 'aportes_descargar'],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: null,
                }
            },
            tipodocumento: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_afiliado",
                    label: 'name'
                }
            },
            documento: {
                type: "number",
                label: "Documento",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    prepend: '',
                    append: '',
                    predeterminate: '',
                    minform: true
                }
            },
            tipo: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "",
                    label: 'name'
                }
            },
            subtipo: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "",
                    label: 'name'
                }
            },
            nombre1: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            nombre2: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            apellido1: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            apellido2: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            extranjero: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            colextranjero: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            fechaextranjero: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            codigoafp: {
                type: "number",
                label: "Documento",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            codigoeps: {
                type: "number",
                label: "Documento",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            codigoccf: {
                type: "number",
                label: "Documento",
                placeholder: "",
                namepath: ['aportes_registrar', 'archivo_aportes'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },

            diasafp: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            diaseps: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            diasriesgo: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            diasccf: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            diasparafiscales: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            salario: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            salariointegral: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            ibcafp: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            ibceps: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            ibcriesgo: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            ibcccf: {
                type: "text",
                label: "Salario CCF",
                placeholder: "",
                namepath: ['aportes_registrar', 'archivo_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            ibcparafiscales: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            tarifaafp: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            tarifaaltoriesgo: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            cotizacionafp: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            voluntariaaportante: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            voluntariaafiliado: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            totalafp: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            solidaridadafp: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            subsistencia: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            retenido: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            tarifaeps: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            cotizacioneps: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            incapacidadeg: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            valoreg: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            licencia: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            valorlicencia: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            valorupc: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            tarifariesgo: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            claseriesgo: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            centrotrabajo: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            cotizacionriesgo: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            epsdestino: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            afpdestino: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            tarifasena: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            cotizacionsena: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            tarifaicbf: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            cotizacionicbf: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            tarifaccf: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            cotizacionccf: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            tarifaesap: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            cotizacionesap: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            tarifamen: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            cotizacionmen: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            exonerado: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            ingreso: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            fechaingreso: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            retiro: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            fecharetiro: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            tda: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            taa: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            vsp: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            iniciovsp: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            vst: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            sln: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            iniciosln: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            finsln: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            ige: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            inicioige: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            finige: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            lma: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            iniciolma: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            finlma: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            vaclr: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            iniciovaclr: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            finvaclr: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            avp: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            vct: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            iniciovct: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            finvct: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            vip: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            corecciones: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            irl: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            inicioirl: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            finirl: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            horas: {
                type: "number",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 240,
                }
            },
            fecha: {
                type: "number",
                label: "Fecha",
                placeholder: "",
                namepath: ['aportes_registrar', 'aportes_descargar'],
                description: "",
                validate: "",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            servicios: {
                type: "text",
                label: "Servicios",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            aporte: {
                type: "number",
                label: "Aporte",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: null,
                }
            },
            dias: {
                type: "number",
                label: "Dias",
                placeholder: "",
                namepath: ['aportes_registrar', 'archivo_retiros'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: null,
                }
            },
            planilla: {
                type: "number",
                label: "No planilla",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: null,
                }
            },
            fechaplanilla: {
                type: "text",
                label: "Fecha planilla",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            id_list_novedad: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "list_novedad",
                    label: 'name'
                }
            },
            id_list_mes: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "list_mes",
                    label: 'name'
                }
            },
            id_list_ano: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "list_ano",
                    label: 'name'
                }
            },
            id_datos_afiliado: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_afiliado",
                    label: 'name'
                }
            },
            id_info_aportes: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "info_aportes",
                    label: 'name'
                }
            },
            id_aportes_registro: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "aportes_registro",
                    label: 'name'
                }
            },
            id_info_afiliacion: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "info_afiliacion",
                    label: 'name'
                }
            },
            id_datos_razon: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_razon",
                    label: 'name'
                }
            },
            id_list_ccf: {
                type: "text",
                label: "CCF",
                placeholder: "",
                namepath: ['archivo_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 20,
                    list: "list_ccf",
                    label: 'name'
                }
            }
        }
    }
}